/* eslint-disable no-unused-vars */
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
import lottie from 'lottie-web';
import observeIntersection from './inc/observeIntersection';
import scriptLoader from './inc/scriptLoader';
import devAt from './inc/devAt';

gsap.registerPlugin(ScrollTrigger);

const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', '100vh');
};

appHeight();

// eslint-disable-next-line no-nested-ternary
const clamp = (num, min, max) => (num <= min ? min : num >= max ? max : num);

const horizontal = () => {
    const horizontalSections = gsap.utils.toArray('.scrollSlideContainer');

    horizontalSections.forEach((container) => {
        const typeSlides = gsap.utils.toArray('.typeSlide');
        const stickyContainers = container.querySelectorAll('.stickyContainer');
        const currentTypeSlide = container.querySelector('#currentTypeSlide');
        const numberTypeSlides = container.querySelector('#numberTypeSlides');
        gsap.to(typeSlides, {
            x: window.innerWidth * typeSlides.length * -2,
            ease: 'none',
            scrollTrigger: {
                trigger: container,
                pin: true,
                autoKill: true,
                overwrite: 5,
                invalidateOnRefresh: true,
                scrub: true,
                end: () => `+=${window.innerWidth * typeSlides.length * 2}`,
                onUpdate: (self) => {
                    numberTypeSlides.textContent = typeSlides.length;
                    const offset = parseFloat(self.progress)
                        * 100
                        * (typeSlides.length * 2);
                    stickyContainers.forEach((sct, i) => {
                        const slidePercentage = 1 / stickyContainers.length;
                        const individualOffset = offset - i * 200;

                        if (
                            self.progress > i * slidePercentage
                            && self.progress <= (i + 1) * slidePercentage
                        ) {
                            currentTypeSlide.textContent = i + 1;
                            sct.style.transform = `translate3d(${individualOffset}%, 0, 0)`;
                            sct.classList.add('morphing');
                            document.body.style.setProperty(
                                '--progress',
                                `${self.progress.toFixed(4) * 100}%`
                            );
                            if (
                                (self.progress % slidePercentage)
                                    * (typeSlides.length * 2)
                                    <= 0.5
                                && (self.progress % slidePercentage)
                                    * (typeSlides.length * 2)
                                    >= 0.1
                            ) {
                                sct.classList.add('filter');
                                sct.classList.add('fontFade');
                            } else {
                                sct.classList.remove('filter');
                            }
                            if (
                                (self.progress % slidePercentage)
                                    * (typeSlides.length * 2)
                                <= 0.2
                            ) {
                                sct.classList.remove('fontFade');
                            }
                            const headlineOne = typeSlides[i].querySelector('.headlineOne');
                            const headlineTwo = typeSlides[i].querySelector('.headlineTwo');
                            if (self.progress === 1) {
                                document.body.style.setProperty(
                                    '--scroll',
                                    typeSlides.length * 2
                                );
                                headlineOne.style.opacity = 0;
                                headlineOne.style.filter = 'blur(50px)';
                                headlineTwo.style.opacity = 1;
                                headlineTwo.style.filter = 'blur(0)';
                            } else {
                                document.body.style.setProperty(
                                    '--scroll',
                                    (self.progress % slidePercentage)
                                        * (typeSlides.length * 2)
                                );
                                const progress = (self.progress % slidePercentage)
                                    * (typeSlides.length * 2);
                                const opacityOne = 1 - clamp(progress * 2.4 - 0.2, 0, 1);
                                const opacityTwo = clamp(
                                    progress * 4 - 0.2,
                                    0,
                                    1
                                );
                                headlineOne.style.opacity = opacityOne;
                                headlineOne.style.filter = `blur(${
                                    (1 - opacityOne) * 50
                                }px)`;
                                headlineTwo.style.opacity = opacityTwo;
                                headlineTwo.style.filter = `blur(${
                                    (1 - opacityTwo) * 50
                                }px)`;
                            }
                        } else {
                            sct.style.transform = 'translate3d(0, 0, 0)';
                            sct.classList.remove('morphing');
                        }
                    });
                },
                onEnter: () => {
                    const pinSpacer = document.querySelector('.pin-spacer');
                    pinSpacer.classList.add('pinned');
                },
                onEnterBack: () => {
                    const pinSpacer = document.querySelector('.pin-spacer');
                    pinSpacer.classList.add('pinned');
                },
                onLeave: () => {
                    const pinSpacer = document.querySelector('.pin-spacer');
                    pinSpacer.classList.remove('pinned');
                },
                onLeaveBack: () => {
                    const pinSpacer = document.querySelector('.pin-spacer');
                    pinSpacer.classList.remove('pinned');
                },
                // onToggle: (self) => {
                //     // console.log(self);
                //     // self.refresh();
                // }
            },
        });
    });
};

const stackCases = () => {
    const casesProgress = document.querySelector('#casesProgress__js');
    const fixCaseProgress = () => {
        casesProgress.classList.toggle('fixed');
    };
    const currentCase = document.querySelector('#currentCase__js');
    const numberCases = document.querySelector('#numberCases__js');
    const caseSections = gsap.utils.toArray('.caseSection');

    numberCases.textContent = caseSections.length;
    const caseProgress = new Array(caseSections.length).fill(0);
    caseSections.forEach((panel, i) => {
        const pin = i !== caseSections.length - 1;
        ScrollTrigger.create({
            trigger: panel,
            start: 'top top',
            pin,
            invalidateOnRefresh: true,
            pinSpacing: false,
            onEnter: () => {
                fixCaseProgress();
                currentCase.textContent = i + 1;
            },
            onLeave: () => {
                fixCaseProgress();
                currentCase.textContent = i + 1;
            },
            onLeaveBack: () => {
                fixCaseProgress();
                currentCase.textContent = i + 1;
            },
            onEnterBack: () => {
                fixCaseProgress();
                currentCase.textContent = i + 1;
            },
            onUpdate: (self) => {
                // console.log(self.progress);
                caseProgress[i] = self.progress;
                const overallProgress = caseProgress.reduce((progress, cp) => progress + cp, 0)
                    / caseProgress.length;
                // console.log(overallProgress);
                document.body.style.setProperty(
                    '--caseprogress',
                    `${overallProgress * 100}%`
                );
            },
        });
    });
};

const mobileTypesSlider = () => {
    const container = document.getElementById('mobileTypes__js');
    if (container) {
        new Swiper(container, {
            loop: false,
            speed: 300,
            effect: 'fade',
            navigation: {
                nextEl: '.right-arrow-image-slider',
                prevEl: '.left-arrow-image-slider',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            modules: [Navigation, Pagination, EffectFade],
        });
    }
};

const header = document.querySelector('header');

let timeout = null;
const content = '';
const hoverPill = document.getElementById('hoverPill__js');

const handleMouseMove = (e) => {
    clearTimeout(timeout);
    const path = e.composedPath();
    if (path.some((el) => el.dataset && el.hasAttribute('data-hover') && el.getAttribute('data-hover') === 'no')) {
        hoverPill.classList.remove('active');
        document.body.classList.remove('noCursor');
    } else if (path.some((el) => el.dataset && el.hasAttribute('data-hover') && el.getAttribute('data-hover') === 'yes')) {
        // content = path.find((el) => el.dataset?.hover)?.dataset?.hover;
        hoverPill.classList.add('active');
        hoverPill.style.transform = `translate3d(${
            e.x - hoverPill.clientWidth / 2
        }px, ${e.y - hoverPill.clientHeight / 2}px, 0)`;
        document.body.classList.add('noCursor');
    } else {
        hoverPill.classList.remove('active');
        document.body.classList.remove('noCursor');
        timeout = setTimeout(() => {
            timeout = null;
        }, 1000);
    }
};

const mainNav = () => {
    const burger = document.getElementById('burger__js');
    const mainContentMenu = document.getElementById('mainContentMenu__js');
    burger.addEventListener('click', () => {
        mainContentMenu.classList.toggle('open');
        burger.classList.toggle('open');
        if (burger.classList.contains('open')) {
            header.style.setProperty('--contentcolor', '#131416');
        } else if (window.intersectingElement) {
            header.style.setProperty('--contentcolor', '#ffffff');
        } else {
            header.style.setProperty('--contentcolor', '#131416');
        }
    });
};

const observeBGIntersection = () => {
    const elContainer = document.querySelectorAll('.pin-spacer, .darkbg, .wp-block-image');
    const intersectingElements = [];
    const elObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const targetIsIntersecting = intersectingElements.findIndex(
                    (e) => e === entry.target
                );
                if (entry.isIntersecting) {
                    intersectingElements.push(entry.target);
                    header.style.setProperty('--contentcolor', '#fff');
                    window.intersectingElement = true;
                } else if (targetIsIntersecting !== -1) {
                    intersectingElements.splice(targetIsIntersecting, 1);
                }
                if (!intersectingElements.length) {
                    header.style.setProperty('--contentcolor', '#131416');
                    window.intersectingElement = false;
                }
            });
        },
        {
            rootMargin: '0% 0% -100% 0%',
        }
    );
    elContainer.forEach((target) => {
        elObserver.observe(target);
    });
};

const video = document.getElementById('headerVideo__js');
const muteButton = document.getElementById('toggleVideoSound__js');
if (muteButton) {
    const muteSvgs = muteButton.querySelectorAll('span');
}

const videoMute = () => {
    muteButton.addEventListener('click', () => {
        if (video.muted === true) {
            video.muted = false;
        } else {
            video.muted = true;
        }
        muteButton.classList.toggle('muted');
    });
};

const muteVideoWhenLeavingViewport = () => {
    const options = {
        rootMargin: '0px 0px -100%',
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                video.muted = true;
                muteButton.classList.add('muted');
            }
        });
    }, options);

    observer.observe(video);

    return observer;
};

const introAnim = () => {
    const container = document.getElementById('start');
    lottie.loadAnimation({
        container, // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: '/wp-content/themes/forme/assets/img/forme_logoani_A_v02.json', // the path to the animation json
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    });
};

let windowWidth = window.innerWidth;

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('home')) {
        const start = document.getElementById('start');
        const main = document.getElementById('main');
        introAnim();
        if (windowWidth >= 992) {
            horizontal();
            stackCases();
        } else {
            mobileTypesSlider();
        }
        muteVideoWhenLeavingViewport();
        setTimeout(() => {
            start.classList.add('hidden');
            // main.classList.add('visible');
            videoMute();
            document.body.classList.add('vis');
            const intro = document.getElementById('intro');
            intro.classList.add('fadeIn');
            setTimeout(() => {
                intro.classList.add('vis');
                video.play();
            }, 2500);
        }, 4000);
    }

    header.style.setProperty('--contentcolor', '#131416');
    devAt();
    mainNav();
    appHeight();
    observeBGIntersection();
});

let resizeTimer;

window.addEventListener('resize', (e) => {
    // appHeight();
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (document.body.classList.contains('home')) {
            // seems the only way to properly refresh the gasp stuff
            if (windowWidth !== window.innerWidth && window.innerWidth >= 992) {
                windowWidth = window.innerWidth;
                window.location.reload(false);
            }
        }
    }, 250);
});

document.addEventListener('mousemove', handleMouseMove);
